import LangEnum from '../../../../lang/LangEnum';
import BrandSplitSelect from '../../../brand-split-settings/BrandSplitSelect';
import { BrandSplitSettings } from '../../../brand-split-settings/brandSplitSettings.types';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';

interface OrderDivisionSectionGeneralSettingsProps {
  selectedSplitSettings: BrandSplitSettings[];
  handleChangeSplitSettings: (keys: string[]) => Promise<void>;
  splitSettings: BrandSplitSettings[];
}

const OrderDivisionSectionGeneralSettings = ({
  handleChangeSplitSettings,
  selectedSplitSettings,
  splitSettings,
}: OrderDivisionSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_ORDER_DIVISION)}
      description={LangEnum.GENERAL_SETTINGS_DIVISION_ORDER_INTERNAL_MESSAGE}
    >
      <BrandSplitSelect
        selectedSplitSettings={selectedSplitSettings.map((split) => split.key)}
        onChange={handleChangeSplitSettings}
        splitSettings={splitSettings}
      />
    </SettingContainer>
  );
};

export default OrderDivisionSectionGeneralSettings;
